module.exports = __webpack_public_path__ + "static/media/redsapp2.ed6298cd.png";